import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import RetrofitEligibilityForm from "@/components/feature/RetrofitEligibilityForm";

const whatHappensNext = [
  { icon: "ri-file-list-3-line", label: "Enquiry Reference", text: "You receive an enquiry reference ID when your details are submitted." },
  { icon: "ri-search-eye-line", label: "Technical Review", text: "The team reviews the vehicle information you provide." },
  { icon: "ri-phone-line", label: "Team Contact", text: "We get in touch to discuss the next step for your vehicle." },
  { icon: "ri-clipboard-line", label: "Assessment", text: "Final feasibility is confirmed only after technical assessment." },
];

export default function EligibilitySection() {
  return (
    <section id="eligibility" className="w-full scroll-mt-24 bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <Reveal className="lg:col-span-4">
            <SectionHeading
              tone="dark"
              eyebrow="Retrofit Eligibility"
              title="Is Your Vehicle Ready for Electric?"
              description="Share a few details about you, your vehicle and how it is used. This helps the team understand whether a retrofit can be considered."
            />

            <div className="mt-8 space-y-4">
              {whatHappensNext.map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-50/10 text-primary-300">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <div>
                    <h3 className="font-label text-xs font-semibold uppercase tracking-[0.12em] text-background-100">
                      {item.label}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-background-300">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <p className="mt-8 rounded-md border border-primary-400/30 bg-primary-500/10 p-4 text-xs leading-relaxed text-primary-200">
              <i className="ri-alert-line mr-2" />
              Submitting this form does not confirm eligibility. Final retrofit feasibility is subject
              to technical assessment.
            </p>
          </Reveal>

          <Reveal delay={0.12} className="lg:col-span-8">
            <RetrofitEligibilityForm />
          </Reveal>
        </div>
      </div>
    </section>
  );
}